import { render, staticRenderFns } from "./makeConfig.vue?vue&type=template&id=b9e38e9a&"
import script from "./makeConfig.vue?vue&type=script&lang=js&"
export * from "./makeConfig.vue?vue&type=script&lang=js&"
import style0 from "./makeConfig.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports